/**
 * RTWO Indexer Engine — Base Service
 */

import { INDEXER_ENGINE_VERSION } from '../domain-models';
import type {
  IIndexerService,
  IndexerServiceDescriptor,
  IndexerServiceStatus,
} from '../service-interfaces';
import type { indexerInternalEventBus } from '../events/indexer-event-bus';

export interface IndexerServiceContext {
  eventBus: typeof indexerInternalEventBus;
}

export abstract class BaseIndexerService implements IIndexerService {
  abstract readonly serviceId: string;
  abstract readonly serviceName: string;
  abstract readonly description: string;
  abstract readonly integrations: string[];
  abstract readonly requiresRPCSource: boolean;
  abstract readonly requiresIndexStorage: boolean;
  readonly version = INDEXER_ENGINE_VERSION.version;

  protected status: IndexerServiceStatus = 'not_initialized';

  constructor(protected readonly context: IndexerServiceContext) {}

  async initialize(): Promise<void> {
    this.status = 'waiting_for_rpc_source';
  }

  getStatus(): IndexerServiceStatus {
    return this.status;
  }

  getDescriptor(): IndexerServiceDescriptor {
    return {
      serviceId: this.serviceId,
      serviceName: this.serviceName,
      version: this.version,
      status: this.status,
      description: this.description,
      integrations: this.integrations,
      requiresRPCSource: this.requiresRPCSource,
      requiresIndexStorage: this.requiresIndexStorage,
    };
  }
}
